import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { trackEvent } from '../lib/analytics';
import { ScrollReveal } from './animations/ScrollReveal';

function CTA({ title, description, primaryText = 'Get Started', primaryLink = '/enquiry', secondaryText, secondaryLink }) {
  const handleClick = (type) => {
    trackEvent('cta_click', { cta_type: type });
  };

  return (
    <section className="relative w-full bg-gradient-to-br from-primary-600 via-primary-500 to-secondary-600 py-10 md:py-12 overflow-hidden z-10">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2"></div>
      </div>
      
      <div className="w-full px-4 sm:px-6 lg:px-12 relative z-10">
        <ScrollReveal delay={0.2} className="max-w-7xl mx-auto text-center">
          <motion.h2 
            className="text-2xl md:text-3xl font-bold text-white mb-3 md:mb-4 drop-shadow-lg"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            {title}
          </motion.h2>
          {description && (
            <motion.p 
              className="text-sm md:text-base text-white/95 mb-6 md:mb-7 leading-relaxed max-w-3xl mx-auto"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              {description}
            </motion.p>
          )}
          <motion.div 
            className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center items-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <Link
                to={primaryLink}
                onClick={() => handleClick('primary')}
                className="btn bg-white text-primary-600 hover:bg-primary-50 shadow-lg hover:shadow-xl transition-all duration-300 font-semibold px-6 py-3 text-sm md:text-base min-w-[160px]"
              >
                {primaryText}
              </Link>
            </motion.div>
            {secondaryText && secondaryLink && (
              <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                <Link
                  to={secondaryLink}
                  onClick={() => handleClick('secondary')}
                  className="btn border-2 border-white text-white hover:bg-white/20 shadow-md hover:shadow-lg transition-all duration-300 font-semibold px-6 py-3 text-sm md:text-base min-w-[160px]"
                >
                  {secondaryText}
                </Link>
              </motion.div>
            )}
          </motion.div>
        </ScrollReveal>
      </div>
    </section>
  );
}

export default CTA;